import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import Integration from './../components/Integration';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    softwares: state.softwares,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Integration);
